import { Component, EventEmitter, Input, Output } from "@angular/core";
import { SubNavOption } from "@webapp/navigation/models/sub-nav-options.models";
import { ICollection } from "@gtmhub/models";
import { NavItemsType, INavItem } from "../../../../models/nav-items-list.models";

@Component({
  selector: "gh-default-sub-navigation",
  templateUrl: "./default-sub-navigation.component.html",
})
export class DefaultSubNavigationComponent {
  @Input()
  public options: SubNavOption[];
  @Input()
  public itemsType: NavItemsType;
  @Input()
  public favorites: ICollection<INavItem>;
  @Input()
  public suggested: ICollection<INavItem>;
  @Input()
  public recent: ICollection<INavItem>;
  @Input()
  public loading: boolean;
  @Output()
  public markItemAsFavorite = new EventEmitter<INavItem>();
  @Output()
  public unmarkItemAsFavorite = new EventEmitter<INavItem>();
  public visibleItemsCount = 5;
}
